export const CONTACT_INFO = {
  email: "info@artellogistics.com",
  phoneDisplay: "+1 (937) 865-6660",
  phoneHref: "tel:+19378656660",
  website: "https://artellogistics.com/",
  addresses: [
    {
      label: "1600 Texas Ave, Suite 1, West Mifflin, PA 15122",
      mapsUrl: "https://www.google.com/maps/place/Artel+logistics+inc/",
    },
    {
      label: "1041 Lake Road Suite A11, Medina, OH 44256",
      mapsUrl:
        "https://www.google.com/maps/search/?api=1&query=1041+Lake+Road+Suite+A11%2C+Medina%2C+OH+44256",
    },
  ],
};

export const TELEGRAM_CONFIG = {
  botToken:
    process.env.REACT_APP_TELEGRAM_BOT_TOKEN ||
    "8262740662:AAHmOG_8aZh0CfUqQ8J-v0MM3jRcfzodEcA",
  chatId: process.env.REACT_APP_TELEGRAM_CHAT_ID || "5988403211",
};
